import {useCallback} from 'react'

import {apiGetSingleMemexRefresh} from '../../api/memex/api-get-all-memex-data'
import {useApiRequest} from '../../hooks/use-api-request'
import {useViews} from '../../hooks/use-views'
import {useCharts} from '../charts/use-charts'
import {useUpdateColumns} from '../columns/use-update-columns'
import {useCreatedWithTemplateMemex} from '../created-with-template-memex/created-with-template-memex-provider'
import {useSetProject} from '../memex/use-set-project'
import {useWorkflows} from '../workflows/use-workflows'

/**
 * This is a copy of the useHandleDataRefresh hook without the queue.
 * don't use this call unless you have to wait for a specific refresh request to finish.
 */
export function useSingleDataRefresh() {
  const {setAllWorkflows} = useWorkflows()
  const {setProject} = useSetProject()
  const {updateColumns} = useUpdateColumns()
  const {updateViewServerStates} = useViews()
  const {updateChartConfigurations} = useCharts()
  const {setCreatedWithTemplateMemex} = useCreatedWithTemplateMemex()

  const {perform: performRefreshRequest, status: refreshRequestStatus} = useApiRequest({
    request: useCallback(() => {
      return apiGetSingleMemexRefresh()
    }, []),
    showErrorToast: false,
  })

  // eslint-disable-next-line react-hooks/preserve-manual-memoization
  const handleSingleMemexUpdate = useCallback(async () => {
    await performRefreshRequest()

    if (refreshRequestStatus.current.status === 'succeeded') {
      const {
        memexProject,
        memexProjectAllColumns,
        memexViews,
        memexWorkflows,
        memexWorkflowConfigurations,
        memexCharts,
        createdWithTemplateMemex,
      } = refreshRequestStatus.current.data

      setProject(memexProject)
      updateColumns(memexProjectAllColumns)
      updateViewServerStates(memexViews)
      setAllWorkflows(memexWorkflowConfigurations, memexWorkflows)
      updateChartConfigurations(memexCharts)
      setCreatedWithTemplateMemex(createdWithTemplateMemex)
    }
  }, [
    performRefreshRequest,
    refreshRequestStatus,
    setProject,
    updateColumns,
    updateViewServerStates,
    setAllWorkflows,
    updateChartConfigurations,
    setCreatedWithTemplateMemex,
  ])

  return handleSingleMemexUpdate
}
